import { render, staticRenderFns } from "./Affiliation.vue?vue&type=template&id=72ad23ab&scoped=true"
import script from "./Affiliation.vue?vue&type=script&lang=js"
export * from "./Affiliation.vue?vue&type=script&lang=js"
import style0 from "./Affiliation.vue?vue&type=style&index=0&id=72ad23ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ad23ab",
  null
  
)

export default component.exports